@let formRef = type() === "submit" ? formId() : undefined;
<button
  #button
  dsThrottleClick
  (throttleClick)="onClickEvent()"
  [throttleTime]="throttleTime()"
  class="ds-button"
  [class]="cssClasses()"
  [type]="type()"
  [disabled]="disabled()"
  [attr.form]="formRef"
  [attr.aria-label]="ariaLabel() || null"
  [attr.aria-expanded]="ariaExpanded()"
  [attr.aria-controls]="ariaControls()"
>
  <ng-content />
</button>
